"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientReducer = exports.markClientSuspended = exports.clearClient = exports.setClient = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var client_storage_1 = require("../../utils/client-storage");
var initialState = {
    client: (0, client_storage_1.loadClientSession)(),
};
var clientSlice = (0, toolkit_1.createSlice)({
    name: "clientSlice",
    initialState: initialState,
    reducers: {
        setClient: function (state, action) {
            state.client = action.payload;
        },
        clearClient: function (state) {
            state.client = null;
        },
        markClientSuspended: function (state) {
            if (state.client)
                state.client.status = "SUSPENDED";
        },
    },
});
exports.setClient = (_a = clientSlice.actions, _a.setClient), exports.clearClient = _a.clearClient, exports.markClientSuspended = _a.markClientSuspended;
exports.clientReducer = clientSlice.reducer;
